<template>
  <path
    d="M20 3.00024H6C4.9 3.00024 4 3.90024 4 5.00024V13.0002C4 15.2102 5.79 17.0002 8 17.0002H14C16.21 17.0002 18 15.2102 18 13.0002V10.0002H20C21.11 10.0002 22 9.10024 22 8.00024V5.00024C22 3.90024 21.1 3.00024 20 3.00024ZM20 8.00024H18V5.00024H20V8.00024ZM5 19.0002H19C19.55 19.0002 20 19.4502 20 20.0002C20 20.5502 19.55 21.0002 19 21.0002H5C4.45 21.0002 4 20.5502 4 20.0002C4 19.4502 4.45 19.0002 5 19.0002Z"
  />
</template>
